'use strict';
// 本番用LINE友だち追加URLをここに設定してください。
const LINE_URL = 'https://lin.ee/nhTtafaF';
if (LINE_URL) {
  const url = new URL(LINE_URL);
  if (url.protocol === 'https:') {
    document.querySelectorAll('[data-line-link]').forEach(link => {
      link.href = url.href;
      link.removeAttribute('aria-disabled');
      link.removeAttribute('role');
      link.removeAttribute('tabindex');
    });
    document.querySelectorAll('[data-line-status]').forEach(note => { note.hidden = true; });
  }
}

// 未受領の差し替え画像は、既存画像で表示を維持します。
// 新しいSVG・PC画像を配置すると、指定ファイルが優先されます。
document.querySelectorAll('img[data-image-fallback]').forEach(img => {
  const showFallback = () => {
    if (!img.dataset.imageFallback) return;
    img.src = img.dataset.imageFallback;
    delete img.dataset.imageFallback;
  };
  img.addEventListener('error', showFallback, { once: true });
  if (img.complete && img.naturalWidth === 0) showFallback();
});

// スクロール位置から表示を判定。SPでも同じ処理で一度だけ表示する。
(() => {
  const selector = [
    '.section__intro', '.copy > *', '.visual', '.connection', '.connection__note > p',
    '.mode > *', '.equalizer__copy', '.equalizer > figure',
    '.closing .container > *', '.cta .container > *', '.footer > img', '.footer small'
  ].join(',');
  const pending = new Set(document.querySelectorAll(selector));
  if (!pending.size) return;

  let scheduled = false;
  function revealVisible() {
    scheduled = false;
    const height = window.innerHeight || document.documentElement.clientHeight;
    pending.forEach(target => {
      const rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.top >= height * 0.95 || rect.bottom <= 0) return;
      target.classList.add('is-visible');
      pending.delete(target);
    });
    if (!pending.size) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      window.removeEventListener('load', schedule);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(revealVisible);
  }
  pending.forEach(target => target.classList.add('reveal'));
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);
  schedule();
})();

// CSSのsmooth対応や端末設定に依存せず、上部まで滑らかにスクロール。
(() => {
  const button = document.querySelector('.back-top');
  if (!button) return;
  let stop = null;
  button.addEventListener('click', event => {
    event.preventDefault();
    if (stop) stop();
    const startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!startY) return;
    const root = document.documentElement;
    const oldBehavior = root.style.getPropertyValue('scroll-behavior');
    const oldPriority = root.style.getPropertyPriority('scroll-behavior');
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    let frame = null;
    let startedAt = null;
    function finish() {
      if (frame !== null) window.cancelAnimationFrame(frame);
      if (oldBehavior) root.style.setProperty('scroll-behavior', oldBehavior, oldPriority);
      else root.style.removeProperty('scroll-behavior');
      window.removeEventListener('touchstart', finish);
      window.removeEventListener('wheel', finish);
      window.removeEventListener('keydown', onKey);
      stop = null;
    }
    function onKey(event) {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) finish();
    }
    function step(timestamp) {
      if (startedAt === null) startedAt = timestamp;
      const progress = Math.min((timestamp - startedAt) / 850, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, Math.round(startY * (1 - eased)));
      if (progress < 1) frame = window.requestAnimationFrame(step);
      else finish();
    }
    stop = finish;
    window.addEventListener('touchstart', finish, { passive: true });
    window.addEventListener('wheel', finish, { passive: true });
    window.addEventListener('keydown', onKey);
    frame = window.requestAnimationFrame(step);
  });
})();
